export default __webpack_public_path__ + "media/images/icons/icon-file-52b8456d6af69f310bd296d0c4c86afb.svg";